"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf3 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

var _FormattedHTMLMessage = _interopRequireDefault(require("I18n/components/FormattedHTMLMessage"));

var _default =
/*#__PURE__*/
function (_React$Component) {
  (0, _inherits2.default)(_default, _React$Component);

  function _default() {
    var _getPrototypeOf2;

    var _this;

    (0, _classCallCheck2.default)(this, _default);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = (0, _possibleConstructorReturn2.default)(this, (_getPrototypeOf2 = (0, _getPrototypeOf3.default)(_default)).call.apply(_getPrototypeOf2, [this].concat(args)));
    _this.state = {
      hidden: false
    };

    _this.closeClicked = function () {
      _this.setState({
        hidden: true
      });
    };

    return _this;
  }

  (0, _createClass2.default)(_default, [{
    key: "render",
    value: function render() {
      if (this.state.hidden) {
        return null;
      }

      var message = this.props.message;
      return _react.default.createElement("div", {
        className: "alert-message-container"
      }, _react.default.createElement("div", {
        className: "alert-message"
      }, _react.default.createElement("span", {
        className: "icon icon-cancel",
        onClick: this.closeClicked
      }), _react.default.createElement(_FormattedHTMLMessage.default, {
        message: message
      })));
    }
  }]);
  return _default;
}(_react.default.Component);

exports.default = _default;
_default.propTypes = {
  message: _propTypes.default.string
};
module.exports = exports.default;


//////////////////
// WEBPACK FOOTER
// ./js/components/AlertMessage.js
// module id = 247
// module chunks = 0